import React from 'react';
import { Link } from 'react-router-dom';
import './Showcase.css';

function Showcase() {
  return (
    <section className="showcase">
      <div className="showcase__image-wrap">
        <img
          src={`${process.env.PUBLIC_URL}/engine.png`}
          alt="Acriolis 976cc V-Twin engine"
          className="showcase__image"
        />
      </div>

      <div className="showcase__content">
        <span className="showcase__eyebrow">ENGINEERED TO EXCEL</span>
        <h2 className="showcase__heading">
          Supreme Power Meets<br />
          Ultimate Versatility
        </h2>
        <p className="showcase__text">
          Our 976cc V-Twin engine delivers exceptional torque,<br />
          smooth power, and efficiency. Built to perform in the<br />
          harshest environments with precision and control.
        </p>
        <Link to="/narsimha" className="showcase__link">
          Explore Technology <span>→</span>
        </Link>
      </div>
    </section>
  );
}

export default Showcase;
